import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";

import PriestProfileContainer from "../components/priest-profile/PriestProfileContainer";
import PriestProfileController from "../components/priest-profile/PriestProfileController";
import PriestProfileTab from "../data/enums/PriestProfileTab";
import UserRole from "../data/enums/UserRole";
import IPriestProfileData from "../data/priest/PriestProfileData";
import ILabelResponse from "../requests/response/LabelResponse";
import useDelete from "../requests/useDelete";
import useDeleteFile from "../requests/useDeleteFile";
import useFetchData from "../requests/useFetchData";
import usePostFiles from "../requests/usePostFiles";
import PageWrapperTwoColumns from "./PageWrapperTwoColumns";

interface IPriestProfilePageProps {
    priestID: number;
    userRole: UserRole | undefined;
}

const PriestProfilePage: React.FC<IPriestProfilePageProps> = (props: IPriestProfilePageProps) => {
    const { priestID, userRole } = props;

    const params = new URLSearchParams(window.location.search);
    const initCurrentTab: string =
        params.get("tab") && (params.get("tab") === PriestProfileTab.files || params.get("tab") === PriestProfileTab.pictures)
            ? PriestProfileTab.general
            : params.get("tab") || PriestProfileTab.general;
    const [currentTab, setCurrentTab] = useState(initCurrentTab);
    const defaultFileList: FileList = FileList.prototype;
    const [files, setFiles] = useState<FileList>(defaultFileList);
    const [fileType, setFileType] = useState<string>("");

    const { response, loading, showError } = useFetchData<IPriestProfileData>(`/priest/${priestID}`);
    const { responsePostFile, errorStatusPostFile, asyncPostFile } = usePostFiles<FileList, IPriestProfileData>(
        `/priests/${priestID}/${fileType}`,
        `${fileType}[]`,
        files
    );
    const { errorStatusDeleteFile, asyncDeleteFile } = useDeleteFile();
    const { response: deleteResponse, showError: showDeleteError, asyncDelete } = useDelete<ILabelResponse>();

    const [priest, setPriest] = useState(response);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        if (!deleteResponse) {
            if (response) {
                setPriest(response);
            }
            if (priest) {
                setPriest(priest);
            }
        }
    }, [priest, response, deleteResponse]);

    return (
        <>
            {deleteResponse && (deleteResponse as ILabelResponse).label.startsWith("info") && <Redirect to="/priests/search" />}
            {priest && <Redirect to={`/priests/profile/${priest.ID}?&tab=${currentTab}`} />}

            <PageWrapperTwoColumns>
                <PriestProfileController currentTab={currentTab} editMode={editMode} setCurrentTab={setCurrentTab} />
                <PriestProfileContainer
                    asyncDelete={asyncDelete}
                    asyncDeleteFile={asyncDeleteFile}
                    asyncPostFile={asyncPostFile}
                    currentTab={currentTab}
                    deleteResponse={deleteResponse}
                    editMode={editMode}
                    errorStatusDeleteFile={errorStatusDeleteFile}
                    errorStatusPostFile={errorStatusPostFile}
                    loading={loading}
                    priest={priest}
                    responsePostFile={responsePostFile}
                    setEditMode={setEditMode}
                    setFileType={setFileType}
                    setFiles={setFiles}
                    setPriest={setPriest}
                    showDeleteError={showDeleteError}
                    showError={showError}
                    userRole={userRole}
                />
            </PageWrapperTwoColumns>
        </>
    );
};

export default PriestProfilePage;
